// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sort-dropdown[data-v-6e45654e]{display:block;line-height:1em}[data-v-6e45654e] .sort-dropdown>.dropdown-menu{line-height:1.5}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
